import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Trash2 } from 'react-feather';

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const LawyerLogTable = ({ useFetchInit, readOnlyMode }) => {

    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    // const { stepApplilication } = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    const { fetchAllLogs } = FetchData
    const { dataLogs, loadingFetchLogs } = fetchAllLogs
    
    // ------------------------------------------------ Actions
    const {
        handleClickDeleteLog
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } =
                    params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "date_log", headerName: "FECHA", minWidth: 150, maxWidth: 150, filter: true },
        { field: "observations", headerName: "OBSERVACIONES", minWidth: 1000, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idlawyerlogs, estado } = params.data
                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        <MenuItem
                            onClick={() => handleClickDeleteLog(idlawyerlogs)}
                            disabled={readOnlyMode}
                        >
                            <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Eliminar" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchLogs)&&(<LinearLoading />)}
            <CustomTableData 
                rowConfig={dataLogs}
                columnConfig={columnConfig}
            />
        </div>
    )
}
